const PUBLISHABLE_KEY='sb_publishable_HvzqHaSi2gSeSaYh167mrw_tiQgrir-';

type GatewayOptions=Omit<RequestInit,'headers'|'cache'|'credentials'>&{
 headers?:Record<string,string>;
 requireSession?:boolean;
 includeApiKey?:boolean;
 fallbackMessage?:string;
 networkMessage?:string;
};

function record(value:unknown):Record<string,unknown>|null{
 return value&&typeof value==='object'&&!Array.isArray(value)?value as Record<string,unknown>:null;
}
function nonce():string{return `${Date.now()}-${Math.random().toString(36).slice(2)}`;}
export function currentSessionToken():string{return localStorage.getItem('summer_session')||'';}
export function gatewayUrl(path:string):string{
 return `/api/supabase.php?path=${encodeURIComponent(path)}&community_api=v5&request=${nonce()}`;
}

export async function gatewayRequest<T>(path:string,options:GatewayOptions={}):Promise<T>{
 const{
  headers:extraHeaders={},requireSession=false,includeApiKey=false,
  fallbackMessage='Der geschützte Bereich konnte nicht geladen werden.',
  networkMessage=fallbackMessage,
  ...requestOptions
 }=options;
 const headers:Record<string,string>={
  accept:'application/json','cache-control':'no-cache',pragma:'no-cache',...extraHeaders,
 };
 if(requireSession){
  const token=currentSessionToken();
  if(!token)throw new Error('Bitte melde dich zuerst an.');
  headers['x-summer-session']=token;
 }
 if(includeApiKey){
  headers.apikey=PUBLISHABLE_KEY;
  headers.authorization=`Bearer ${PUBLISHABLE_KEY}`;
 }
 if(requestOptions.body&&!(requestOptions.body instanceof FormData)&&!Object.keys(headers).some(key=>key.toLowerCase()==='content-type'))headers['content-type']='application/json';
 let response:Response;
 try{
  response=await fetch(gatewayUrl(path),{
   ...requestOptions,headers,cache:'no-store',credentials:'same-origin',
  });
 }catch(reason){
  console.error('community_gateway_network_error',{path,reason});
  throw new Error(networkMessage);
 }
 const payload:unknown=await response.json().catch(()=>({}));
 const item=record(payload);
 const explicitError=typeof item?.error==='string'?item.error:'';
 const responseMessage=!response.ok&&typeof item?.message==='string'?item.message:'';
 if(!response.ok||explicitError)throw new Error(explicitError||responseMessage||fallbackMessage);
 return payload as T;
}

export function edgeRequest<T>(functionName:string,path='',options:GatewayOptions={}):Promise<T>{
 return gatewayRequest<T>(`/functions/v1/${functionName}${path}`,{
  ...options,requireSession:options.requireSession??true,
 });
}

export function rpcRequest<T>(name:string,args:Record<string,unknown>,fallbackMessage:string):Promise<T>{
 return gatewayRequest<T>(`/rest/v1/rpc/${name}`,{
  method:'POST',body:JSON.stringify(args),includeApiKey:true,fallbackMessage,
  networkMessage:'Die Verbindung zum geschützten Dienst konnte nicht hergestellt werden. Bitte versuche es noch einmal.',
 });
}
